import React, { useContext } from 'react';
import 'twin.macro';
import { PreferenceContext } from '../context';
import { DropDown, DropDownItem } from '../dropdown';
import { searchSortings } from '../../data/sortings';
import { SortIconDown, SortIconUp } from 'icons';

export const SearchSorting = ({ onClick }) => {
  const {
    preference: {
      sorting,
      sorting: { search: searchSortPref },
    },
    setPreference,
  } = useContext(PreferenceContext);
  const activeItem = searchSortings.find((item) => item.value === searchSortPref);
  return (
    <DropDown
      label={searchSortPref && activeItem ? activeItem.label : 'sorteren'}
      isRight
      iconProps={{
        Type: activeItem && activeItem.direction === 'up' ? SortIconUp : SortIconDown,
        animate: true,
      }}
      buttonProps={{ secondary: true }}
    >
      {searchSortings.map((option) => (
        <DropDownItem
          label={option.label}
          key={option.label}
          selectedValue={searchSortPref === option.value}
          onClick={() => {
            setPreference({ sorting: { ...sorting, search: option.value } });
            if (onClick) {
              onClick();
            }
          }}
        />
      ))}
    </DropDown>
  );
};
